import PropTypes from "prop-types";
import React from "react";

import { ButtonSizes } from "../constants";

import "./styles.scss";
import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";

export const Button = ({
  children,
  className,
  name,
  type,
  disabled,
  buttonType,
  onClick,
  buttonSize,
  testId,
  ...props
}) => {
  const classNameArray = ["apti-CL apti-Button", className, buttonType];

  if (buttonSize !== ButtonSizes.normal) {
    classNameArray.push(buttonSize);
  }

  return (
    <button
      className={createClassNameString(classNameArray)}
      name={name}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...getAutomationDataAttr(testId)}
      {...props}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]).isRequired,
  className: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.oneOf(["button", "reset", "submit"]),
  disabled: PropTypes.bool,
  buttonType: PropTypes.oneOf([
    "primary",
    "primary-v2",
    "primary-v3",
    "primary-outline",
    "primary-v2-outline",
    "secondary",
    "secondary-outline",
    "label",
  ]),
  size: PropTypes.oneOf(["small", "normal"]),
  onClick: PropTypes.func.isRequired,
  testId: PropTypes.string,
};

Button.defaultProps = {
  children: <></>,
  className: undefined,
  name: "",
  type: "button",
  disabled: false,
  buttonType: undefined,
  size: "normal",
  onClick: () => {},
  testId: undefined,
};
